<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px" y="0px"
    :width="width"
    :height="height"
    xml:space="preserve"
    viewBox="0 0 20 20"
    role="presentation"
    :fill="iconColor">
    <defs>
        <path id="a" d="M14.875 7.088h-.813V5.463A4.064 4.064 0 0 0 10 1.4a4.064 4.064 0 0 0-4.063 4.063v1.625h-.812A1.63 1.63 0 0 0 3.5 8.713v8.124a1.63 1.63 0 0 0 1.625 1.625h9.75a1.63 1.63 0 0 0 1.625-1.625V8.713a1.63 1.63 0 0 0-1.625-1.625zM10 14.4a1.63 1.63 0 0 1-1.625-1.625A1.63 1.63 0 0 1 10 11.15a1.63 1.63 0 0 1 1.625 1.625A1.63 1.63 0 0 1 10 14.4zm2.519-7.313H7.48V5.463A2.52 2.52 0 0 1 10 2.943a2.52 2.52 0 0 1 2.519 2.52v1.625z"/>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <mask id="b" fill="#fff">
            <use xlink:href="#a"/>
        </mask>
        <use fill="#000" xlink:href="#a"/>
        <g fill="#8A8F9C" mask="url(#b)">
            <path d="M0 0h20v20H0z"/>
        </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: '32px'
    },
    height: {
      type: [Number, String],
      default: '32px'
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
};
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
  margin-bottom: -2px; /* yes, I'm that particular about formatting */
}
</style>
